import { baseBuild } from '@/core/services/network/config/baseBuild';
import type { AppDispatch } from '@/app/store/store';
import { createSimilarDesignsService } from '../application/services/SimilarDesignsService';
import { SimilarDesignsAdapter } from '../infra/adapters/similarDesigns.adapter';

export function similarDesignsBuild(dispatch: AppDispatch) {
  return baseBuild(
    (d: AppDispatch) => new SimilarDesignsAdapter(d),
    (repo) => createSimilarDesignsService(repo),
    dispatch,
  );
}
